import { render, staticRenderFns } from "./FeedbackAverage.vue?vue&type=template&id=6acb0948"
import script from "./FeedbackAverage.vue?vue&type=script&lang=js"
export * from "./FeedbackAverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports